import { apiClient } from './clienteHttp';

export interface ServicioSatEstado {
  nombre: string;
  url: string;
  disponible: boolean;
  http_status: number | null;
  latencia_ms: number;
  error: string | null;
}

export interface EstadoSatResponse {
  servicios: ServicioSatEstado[];
  todos_disponibles: boolean;
  checado_at: string;
}

export async function getEstadoSat(): Promise<EstadoSatResponse> {
  const res = await apiClient.get('/estado-sat');
  return res.data;
}
